import { API_URLS, customAxios } from "../config";

export const getRegisterDetails = (query = "") =>
  customAxios
    .get(API_URLS.getRegisterDetails + query)
    .then((res) => res?.data)
    .catch((error) => error);

export const saveRegisterDetails = (payload) =>
  customAxios
    .post(API_URLS.getRegisterDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const saveLoginDetails = (payload) =>
  customAxios
    .post(API_URLS.getLoginDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveUserActivation = (payload) =>
  customAxios
    .post(API_URLS.saveUserActivation, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const saveForgotDetails = (payload) =>
  customAxios
    .post(API_URLS.getForgotDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getSetupDetails = (query = "") =>
  customAxios
    .get(API_URLS.getSetupDetails + query)
    .then((res) => res?.data)
    .catch((error) => error);

export const getStartedDetails = (query = "") =>
  customAxios
    .get(API_URLS.getStartedDetails + query)
    .then((res) => res?.data)
    .catch((error) => error);

export const saveRequestApi = (payload) =>
  customAxios
    .post(API_URLS.saveRequestApi, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const getProfileDetails = (query = "") =>
  customAxios
    .get(API_URLS.getProfileDetails + query)
    .then((res) => res?.data)
    .catch((error) => error);

export const saveSetupZero = (payload) =>
  customAxios
    .post(API_URLS.saveSetupZero, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveSetupOne = (payload) =>
  customAxios
    .post(API_URLS.saveSetupOne, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveSetupTwo = (payload) =>
  customAxios
    .post(API_URLS.saveSetupTwo, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveSetupThree = (payload) =>
  customAxios
    .post(API_URLS.saveSetupThree, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveSetupFour = (payload) =>
  customAxios
    .post(API_URLS.saveSetupFour, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveSetupFive = (payload) =>
  customAxios
    .post(API_URLS.saveSetupFive, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveSetupSix = (payload) =>
  customAxios
    .post(API_URLS.saveSetupSix, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveSetupSeven = (payload) =>
  customAxios
    .post(API_URLS.saveSetupSeven, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveSetupEight = (payload) =>
  customAxios
    .post(API_URLS.saveSetupEight, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveSetupNine = (payload) =>
  customAxios
    .post(API_URLS.saveSetupNine, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveGettingStarted = (payload) =>
  customAxios
    .post(API_URLS.getStartedDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const checkTaxYear = (payload) =>
  customAxios
    .post(API_URLS.checkTaxYear, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const getTaxYearEndDate = (payload) =>
  customAxios
    .post(API_URLS.getTaxYearEndDate, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveAccountingPeriod = (payload) =>
  customAxios
    .post(API_URLS.saveAccountingPeriod, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const editAccountingPeriod = (payload) =>
  customAxios
    .post(API_URLS.editAccountingPeriod, payload, {
      disableLoading: true,
    })
    .then((res) => res?.data)
    .catch((error) => error);
export const savePayrollFrequency = (payload) =>
  customAxios
    .post(API_URLS.savePayrollFrequency, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const editPayrollFrequency = (payload) =>
  customAxios
    .post(API_URLS.editPayrollFrequency, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const getAccrualTypes = (query = "") =>
  customAxios
    .get(API_URLS.getAccrualTypes + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveLeaveRule = (payload) =>
  customAxios
    .post(API_URLS.saveLeaveRule, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const editLeaveRule = (payload) =>
  customAxios
    .post(API_URLS.editLeaveRule, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveOvertimeRule = (payload) =>
  customAxios
    .post(API_URLS.saveOvertimeRule, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const editOvertimeRule = (payload) =>
  customAxios
    .post(API_URLS.editOvertimeRule, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveMealRule = (payload) =>
  customAxios
    .post(API_URLS.saveMealRule, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const editMealRule = (payload) =>
  customAxios
    .post(API_URLS.editMealRule, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveIncentiveRule = (payload) =>
  customAxios
    .post(API_URLS.saveIncentiveRule, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const editIncentiveRule = (payload) =>
  customAxios
    .post(API_URLS.editIncentiveRule, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveBlackoutRule = (payload) =>
  customAxios
    .post(API_URLS.saveBlackoutRule, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const editBlackoutRule = (payload) =>
  customAxios
    .post(API_URLS.editBlackoutRule, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const savePerformanceRule = (payload) =>
  customAxios
    .post(API_URLS.savePerformanceRule, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const editPerformanceRule = (payload) =>
  customAxios
    .post(API_URLS.editPerformanceRule, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const deleteLaborRule = (payload) =>
  customAxios
    .post(API_URLS.deleteLaborRule, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveUploadStaff = (payload) =>
  customAxios
    .post(API_URLS.saveUploadStaff, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const downloadStaffTemplate = (query = "") =>
  customAxios
    .get(API_URLS.downloadStaffTemplate + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const downloadPayeeTemplate = (query = "") =>
  customAxios
    .get(API_URLS.downloadPayeeTemplate + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const saveUploadPayee = (payload) =>
  customAxios
    .post(API_URLS.saveUploadPayee, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const backButtonHandler = (payload) =>
  customAxios
    .post(API_URLS.backButtonHandler, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const applyPromoWizard = (payload) =>
  customAxios
    .post(API_URLS.applyPromoWizard, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const removePromoWizard = (payload) =>
  customAxios
    .post(API_URLS.removePromoWizard, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const removeUploadStaff = (query = "") =>
  customAxios
    .get(API_URLS.removeUploadStaff + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const getStateDetails = (query = "") =>
  customAxios
    .get(API_URLS.getStateDetails + query)
    .then((res) => res?.data)
    .catch((error) => error);
export const removeUploadPayee = (query = "") =>
  customAxios
    .get(API_URLS.removeUploadPayee + query)
    .then((res) => res?.data)
    .catch((error) => error);

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getRegisterDetails,
  saveRegisterDetails,
  saveLoginDetails,
  saveForgotDetails,
  saveUserActivation,
  getStartedDetails,
  getSetupDetails,
  saveRequestApi,
  getProfileDetails,
  getStateDetails,
  saveSetupZero,
  saveSetupOne,
  saveSetupTwo,
  saveSetupThree,
  saveSetupFour,
  saveSetupFive,
  saveSetupSix,
  saveSetupSeven,
  saveSetupEight,
  saveGettingStarted,
  checkTaxYear,
  getTaxYearEndDate,
  saveAccountingPeriod,
  editAccountingPeriod,
  savePayrollFrequency,
  editPayrollFrequency,
  getAccrualTypes,
  saveLeaveRule,
  editLeaveRule,
  saveOvertimeRule,
  editOvertimeRule,
  saveMealRule,
  editMealRule,
  saveIncentiveRule,
  editIncentiveRule,
  saveBlackoutRule,
  editBlackoutRule,
  savePerformanceRule,
  editPerformanceRule,
  deleteLaborRule,
  saveUploadStaff,
  downloadStaffTemplate,
  saveUploadPayee,
  downloadPayeeTemplate,
  backButtonHandler,
  applyPromoWizard,
  removePromoWizard,
  saveSetupNine,
  removeUploadStaff,
  removeUploadPayee,
};
